export default function NotFound() {
    return (
        <>
            <div className="dark:bg-gray-800 text-9xl text-amber-800 text-center">
                404
            </div>
            <div className="dark:bg-gray-800 text-9xl text-amber-800 text-center">
                Page Not Found
            </div>
        </>
    )
}
